import {
  addDays,
  differenceInDays,
  endOfDay,
  format,
  isBefore,
  isSameDay,
  isSameYear,
} from 'date-fns';
import { TFunction } from 'i18next';
import { Timestamp } from 'shared/types/timestamp';

export type GetSmartDateLabelOptions = {
  enableWeekdays?: boolean;
};

export const getSmartDateLabel = (
  date: Timestamp,
  today: Timestamp,
  t: TFunction,
  options?: GetSmartDateLabelOptions,
) => {
  if (isSameDay(date, today)) {
    return t('general.labels.dates.today');
  }

  if (options?.enableWeekdays) {
    if (isSameDay(date, addDays(today, 1))) {
      return t('general.labels.dates.tomorrow');
    }

    const diff = differenceInDays(endOfDay(date), endOfDay(today));
    if (diff > 1 && diff < 7) {
      return format(date, 'EEEE');
    }
  }

  if (isBefore(date, today)) {
    return t('general.labels.days-ago.mid-short', {
      count: differenceInDays(endOfDay(today), endOfDay(date)),
    });
  }

  const dateFormat = isSameYear(date, today) ? 'MMM d' : "MMM d, ''yy";
  return format(date, dateFormat);
};
